/* Salt & Field — the only JS the storefront needs.
   Progressive enhancement: every control works without it. */
(function () {
  'use strict';

  /* ---------- mobile navigation ---------- */
  var btn = document.querySelector('.sf-navtoggle');
  var nav = document.getElementById('sf-nav');

  if (btn && nav) {
    var root = document.documentElement;

    function isOpen() { return btn.getAttribute('aria-expanded') === 'true'; }

    function setOpen(open, returnFocus) {
      btn.setAttribute('aria-expanded', String(open));
      root.classList.toggle('sf-nav-open', open);
      if (open) {
        var first = nav.querySelector('a, button');
        if (first) first.focus();
      } else if (returnFocus) {
        btn.focus();
      }
    }

    btn.addEventListener('click', function () { setOpen(!isOpen(), true); });

    /* Escape has to work from anywhere while the menu is open — the toggle is a
       sibling of the nav, so a listener bound to the nav alone never fired. */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) setOpen(false, true);
    });

    /* an in-page anchor leaves the menu open with a stale aria-expanded */
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a') && isOpen()) setOpen(false, false);
    });

    /* crossing the breakpoint with the drawer open strands the state */
    if (window.matchMedia) {
      var wide = window.matchMedia('(min-width: 990px)');
      var onChange = function (e) { if (e.matches && isOpen()) setOpen(false, false); };
      if (wide.addEventListener) wide.addEventListener('change', onChange);
      else if (wide.addListener) wide.addListener(onChange);
    }
  }

  /* ---------- Ingredients: sticky rail scroll-spy ---------- */
  var railLinks = document.querySelectorAll('.sf-rail a, nav[aria-label] .sf-rail a');
  if (railLinks.length && 'IntersectionObserver' in window) {
    var targets = [];
    railLinks.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var t = document.getElementById(href.slice(1));
      if (t) targets.push([t, a]);
    });

    if (targets.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          railLinks.forEach(function (a) {
            a.classList.remove('is-active');
            /* colour alone is not a state — announce it too */
            a.removeAttribute('aria-current');
          });
          var hit = targets.find(function (pair) { return pair[0] === en.target; });
          if (hit) {
            hit[1].classList.add('is-active');
            hit[1].setAttribute('aria-current', 'true');
          }
        });
      }, { rootMargin: '-100px 0px -70% 0px' });
      targets.forEach(function (pair) { io.observe(pair[0]); });
    }
  }
})();

/* --- ingredient-guide rail lift -------------------------------------------
   The rail lives in the guide section, but the section above it already renders
   on the same grid and already leaves the 220px rail column empty. Measured on
   the live page at 1440px: the rail started 866px below the column that was
   waiting for it, so the contents only appeared after a screen and a half of
   scrolling. The target is the handoff's own alignment: the rail's first item sits
   level with the first line of body copy, not above it. So measure from the rail to
   the TOP OF THE FIRST GRID on the page -- the one holding the empty rail column --
   and publish that as --sf-rail-lift; the CSS pulls the rail up by it above 990px.
   Measuring the section instead overshot by its top padding and floated the rail
   166px clear of the copy. Re-measured on resize; defaults to 0 if anything fails. */
(function () {
  var rail = document.querySelector('.sf-rail');
  if (!rail) return;
  var own = rail.closest('.s424');
  if (!own) return;
  function lift() {
    document.documentElement.style.setProperty('--sf-rail-lift', '0px');
    if (window.innerWidth < 990) return;
    var grids = document.querySelectorAll('.s424');
    var first = grids[0];
    if (!first || first === own) return;
    var gap = rail.getBoundingClientRect().top - first.getBoundingClientRect().top;
    if (!(gap > 0)) return;
    document.documentElement.style.setProperty('--sf-rail-lift', Math.round(gap) + 'px');
  }
  lift();
  window.addEventListener('resize', lift, { passive: true });
  window.addEventListener('load', lift);
})();
